export default "__VITE_ASSET__htyAHctZ__"